module.exports = __webpack_public_path__ + "static/images/icon-game-new4.3268c0e.png";